import { createSelector } from '@ngrx/store';

import { IState } from '@store/index';

import { ITimezonesState, timezonesFeatureKey } from './timezones.reducer';
import { ITimezone } from '@interfaces/timezones.interface';

export const getTimezonesState = (state: IState): ITimezonesState => state[timezonesFeatureKey];

export const selectTimezones = (state: ITimezonesState): ITimezone[] => state.timezones;

export const selectTimezonesLoading = (
  state: ITimezonesState,
): { isFetching: boolean; isError: boolean } => ({
  isFetching: state.fetching,
  isError: state.error,
});

export const getTimezones = createSelector(getTimezonesState, selectTimezones);
export const getTimezonesLoading = createSelector(getTimezonesState, selectTimezonesLoading);
